export default __webpack_public_path__ + "static/media/detail.8b7e9558.svg";